var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"spirit-guide"}),_c('h1',[_vm._v(_vm._s(_vm.text))]),(_vm.loadingStatus !== '')?_c('h3',[_vm._v(_vm._s(_vm.loadingStatus))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }